import React from "react";

const BillOrderProduct = ({ menuItem = {} }) => {
  const orderDetails = menuItem?.menuOrderDetails || [];
  const subTotal = orderDetails.reduce(
    (acc, item) => acc + item?.menuItemDetail?.price * item?.quantity,
    0
  );
  const discount = menuItem?.discountAmount || 0;
  const finalAmount = subTotal - discount;
  const currency = orderDetails[0]?.menuItemDetail?.currency || "";

  return (
    <div className="border p-3 rounded bg-white shadow-sm">
      <h5 className="text-center fw-bold">Bill Receipt</h5>
      <table className="table table-sm table-borderless">
        <thead className="border-bottom">
          <tr>
            <th className="text-start">Item</th>
            <th className="text-end">Price ({currency})</th>
            <th className="text-end">Qty</th>
            <th className="text-end">Total ({currency})</th>
          </tr>
        </thead>
        <tbody>
          {orderDetails.map((item, index) => (
            <tr key={index}>
              <td>{item?.menuItemDetail?.title}</td>
              <td className="text-end">{item?.menuItemDetail?.price}</td>
              <td className="text-end">{item?.quantity}</td>
              <td className="text-end">{item?.menuItemDetail?.price * item?.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Total Summary */}
      <div className="border-top pt-2">
        <table className="table table-sm table-borderless">
          <tbody>
            <tr>
              <td className="text-end fw-bold">Sub Total:</td>
              <td className="text-end">{subTotal} {currency}</td>
            </tr>
            <tr>
              <td className="text-end text-danger fw-bold">Discount:</td>
              <td className="text-end text-danger">- {discount} {currency}</td>
            </tr>
            <tr className="border-top border-dark">
              <th className="text-end fs-5">Grand Total:</th>
              <th className="text-end fs-5">{finalAmount} {currency}</th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BillOrderProduct;
